import { uuidGenerate } from "./schema";

export var Inputs = /** @class */ (function () {
  function Inputs() {}
  Inputs.USER_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/users",
        reduce: function (user) {
          return user.id;
        },
        getOptionLabel: function (user) {
          return user.full_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    full_name: {
      component: "FormInput",
      key: "full_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    username: {
      component: "FormInput",
      key: "username",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    email: {
      component: "FormInput",
      key: "email",
      attrs: {
        id: uuidGenerate(),
        rules: "required|email",
      },
    },
    mobile: {
      component: "FormInput",
      key: "mobile",
      attrs: {
        id: uuidGenerate(),
        rules: "required|digits:10|min:10|max:10",
      },
    },
    phone: {
      component: "FormInput",
      key: "phone",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    dob: {
      component: "FormMultiDatepicker",
      key: "dob",
      attrs: {
        id: uuidGenerate(),
      },
    },
    is_blocked: {
      component: "FormSelect",
      key: "is_blocked",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    is_locked: {
      component: "FormSelect",
      key: "is_locked",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    password_must_change: {
      component: "FormSelect",
      key: "password_must_change",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.NGO_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ngos",
        reduce: function (ngo) {
          return ngo.id;
        },
        getOptionLabel: function (ngo) {
          return ngo.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    acronym: {
      component: "FormInput",
      key: "acronym",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    decision_no: {
      component: "FormInput",
      key: "decision_no",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    decision_date: {
      component: "FormMultiDatepicker",
      key: "decision_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    status_date: {
      component: "FormMultiDatepicker",
      key: "decision_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    has_public_benefit: {
      component: "FormSelect",
      key: "has_public_benefit",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    has_organizational_structure: {
      component: "FormSelect",
      key: "has_organizational_structure",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    has_emp_internal_system: {
      component: "FormSelect",
      key: "has_emp_internal_system",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    has_women_private_system: {
      component: "FormSelect",
      key: "has_women_private_system",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    has_volunteering_system: {
      component: "FormSelect",
      key: "has_volunteering_system",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    is_all_syria_covered: {
      component: "FormSelect",
      key: "is_all_syria_covered",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    dissolution_date: {
      component: "FormMultiDatepicker",
      key: "decision_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    objectives: {
      component: "FormInput",
      key: "objectives",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    neighborhood: {
      component: "FormInput",
      key: "neighborhood",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    address: {
      component: "FormInput",
      key: "address",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    longitude: {
      component: "FormInput",
      key: "longitude",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    latitude: {
      component: "FormInput",
      key: "latitude",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    qr_active: {
      component: "FormSelect",
      key: "qr_active",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    completed_by_ngo_at: {
      component: "FormMultiDatepicker",
      key: "completed_by_ngo_at",
      attrs: {
        id: uuidGenerate(),
      },
    },
    completed_by_directorate_at: {
      component: "FormMultiDatepicker",
      key: "completed_by_directorate_at",
      attrs: {
        id: uuidGenerate(),
      },
    },
    completed_by_ministry_at: {
      component: "FormMultiDatepicker",
      key: "completed_by_ministry_at",
      attrs: {
        id: uuidGenerate(),
      },
    },
    created_at: {
      component: "FormInput",
      key: "created_at",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    updated_at: {
      component: "FormInput",
      key: "updated_at",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    deleted_at: {
      component: "FormInput",
      key: "deleted_at",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.NGO_CLASSIFICATION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/classifications",
        reduce: function (classification) {
          return classification.id;
        },
        getOptionLabel: function (classification) {
          return classification.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.BRANCH_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/branches",
        reduce: function (branch) {
          return branch.id;
        },
        getOptionLabel: function (branch) {
          return branch.governorate_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    services: {
      component: "FormInput",
      key: "services",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    address: {
      component: "FormInput",
      key: "address",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    headquarters_type: {
      component: "FormInput",
      key: "headquarters_type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    decision_date: {
      component: "FormMultiDatepicker",
      key: "decision_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    management_committee: {
      component: "FormInput",
      key: "management_committee",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    longitude: {
      component: "FormInput",
      key: "longitude",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    latitude: {
      component: "FormInput",
      key: "latitude",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.EMPLOYEE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/employees",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.first_name + employee.last_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    insurance_number: {
      component: "FormInput",
      key: "insurance_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    first_name: {
      component: "FormInput",
      key: "first_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    last_name: {
      component: "FormInput",
      key: "last_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    father_name: {
      component: "FormInput",
      key: "father_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    mother_name: {
      component: "FormInput",
      key: "mother_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    birthday: {
      component: "FormMultiDatepicker",
      key: "birthday",
      attrs: {
        id: uuidGenerate(),
      },
    },
    id_number: {
      component: "FormInput",
      key: "id_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    position: {
      component: "FormInput",
      key: "position",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    contact_number: {
      component: "FormInput",
      key: "contact_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    address: {
      component: "FormInput",
      key: "address",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    work: {
      component: "FormInput",
      key: "work",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    qualifications: {
      component: "FormInput",
      key: "qualifications",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    employment_date: {
      component: "FormMultiDatepicker",
      key: "employment_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    resignation_date: {
      component: "FormMultiDatepicker",
      key: "employment_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    gander: {
      component: "FormSelect",
      key: "gander",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    member_status: {
      component: "FormSelect",
      key: "member_status",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    is_holds_disability_card: {
      component: "FormSelect",
      key: "is_holds_disability_card",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.EMPLOYEE_ROLE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/employee-roles",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.EMPLOYMENT_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/employment-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.BRANCH_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/branch-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.CONTACT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/contacts",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.value;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    type: {
      component: "FormInput",
      key: "type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    value: {
      component: "FormInput",
      key: "value",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    icon: {
      component: "FormInput",
      key: "icon",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.AGE_CATEGORY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/categories",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    icon: {
      component: "FormInput",
      key: "icon",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.GOVERNORATE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/governorates",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    phone_prefix: {
      component: "FormInput",
      key: "phone_prefix",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_governorate: {
      component: "FormSelect",
      key: "is_governorate",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.MACHINE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/machines",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.serial_number;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    model: {
      component: "FormInput",
      key: "model",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    plate_number: {
      component: "FormInput",
      key: "plate_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    serial_number: {
      component: "FormInput",
      key: "serial_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    structure_no: {
      component: "FormInput",
      key: "structure_no",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    fuel_type: {
      component: "FormInput",
      key: "fuel_type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    passengers_number: {
      component: "FormInput",
      key: "passengers_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    year: {
      component: "FormInput",
      key: "year",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    tax: {
      component: "FormSelect",
      key: "tax",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.MACHINE_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/machine-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.POSSESSIVE_FORM_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/possessive-forms",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.REAL_ESTATES_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/real-estates",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.number;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    number: {
      component: "FormInput",
      key: "number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    region: {
      component: "FormInput",
      key: "region",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_operating: {
      component: "FormSelect",
      key: "is_operating",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.ESTATE_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/estate-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.NEWS_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/news",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.title_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    title_ar: {
      component: "FormInput",
      key: "title_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    title_en: {
      component: "FormInput",
      key: "title_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description_ar: {
      component: "FormInput",
      key: "description_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description_en: {
      component: "FormInput",
      key: "description_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    accomplished_at_date: {
      component: "FormMultiDatepicker",
      key: "decision_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.CAMPAIGN_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/campaigns",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description_ar: {
      component: "FormInput",
      key: "description_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description_en: {
      component: "FormInput",
      key: "description_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    start_date: {
      component: "FormMultiDatepicker",
      key: "start_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    end_date: {
      component: "FormMultiDatepicker",
      key: "end_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    campaign_amount: {
      component: "FormInput",
      key: "campaign_amount",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    count: {
      component: "FormInput",
      key: "count",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    campaign_type: {
      component: "FormSelect",
      key: "campaign_type",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "مادية",
            value: true,
          },
          {
            text: "عينية",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    is_active: {
      component: "FormSelect",
      key: "is_active",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    featured: {
      component: "FormSelect",
      key: "is_active",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    confirmed: {
      component: "FormSelect",
      key: "confirmed",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.OPPORTUNITY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/opportunities",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    type: {
      component: "FormInput",
      key: "type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    vacancies_number: {
      component: "FormInput",
      key: "vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    opportunity_objectives_ar: {
      component: "FormInput",
      key: "opportunity_objectives_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    opportunity_objectives_en: {
      component: "FormInput",
      key: "opportunity_objectives_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    employment_type_ar: {
      component: "FormInput",
      key: "employment_type_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    employment_type_en: {
      component: "FormInput",
      key: "employment_type_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    skill_ar: {
      component: "FormInput",
      key: "skill_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    skill_en: {
      component: "FormInput",
      key: "skill_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    certificate_ar: {
      component: "FormInput",
      key: "certificate_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    certificate_en: {
      component: "FormInput",
      key: "certificate_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    experience_ar: {
      component: "FormInput",
      key: "experience_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    experience_en: {
      component: "FormInput",
      key: "experience_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    starting_date: {
      component: "FormMultiDatepicker",
      key: "starting_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    closing_date: {
      component: "FormMultiDatepicker",
      key: "closing_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.POSITION_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/position-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.NGO_STATUS_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ngo-status",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.SERVICE_CENTRE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/service-centres",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    clearance_decision_no: {
      component: "FormInput",
      key: "clearance_decision_no",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    switchboard: {
      component: "FormInput",
      key: "switchboard",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    address: {
      component: "FormInput",
      key: "address",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    status: {
      component: "FormSelect",
      key: "status",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "فعال",
            value: true,
          },
          {
            text: "غير فعال",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.LEGAL_FORM_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/legal-forms",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.SERVICE_CENTRE_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/service-centre-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.CLEARANCE_AUTHORITY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/clearance-authorities",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.AREA_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/areas",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    alias_name: {
      component: "FormInput",
      key: "alias_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    level: {
      component: "FormInput",
      key: "level",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    longitude: {
      component: "FormInput",
      key: "longitude",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    latitude: {
      component: "FormInput",
      key: "latitude",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.SERVICE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/services",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description: {
      component: "FormInput",
      key: "description",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.NGO_SERVICE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ngo-services",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.description;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    description: {
      component: "FormInput",
      key: "description",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.SERVICE_FREQUENCY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/service-frequencies",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.SERVICE_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/service-types",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description: {
      component: "FormInput",
      key: "description",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.SERVICE_STATUS_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/service-status",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    color: {
      component: "FormInput",
      key: "color",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.BANK_ACCOUNT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/bank-accounts",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.branch_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    branch_name: {
      component: "FormInput",
      key: "branch_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    account_no: {
      component: "FormInput",
      key: "account_no",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_available: {
      component: "FormSelect",
      key: "campaign_type",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.BANK_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/banks",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.ACCOUNT_MANAGER_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/account-managers",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.full_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    full_name: {
      component: "FormInput",
      key: "full_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    id_number: {
      component: "FormInput",
      key: "id_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    assign_date: {
      component: "FormMultiDatepicker",
      key: "assign_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.PROGRAM_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/programs",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    objectives: {
      component: "FormInput",
      key: "objectives",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    start_date: {
      component: "FormMultiDatepicker",
      key: "start_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    end_date: {
      component: "FormMultiDatepicker",
      key: "end_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.ACTIVITY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/activities",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    objectives: {
      component: "FormInput",
      key: "objectives",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    activity_type: {
      component: "FormSelect",
      key: "activity_type",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "مرتبط بخطة",
            value: 0,
          },
          {
            text: "طارئ",
            value: 1,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.PLAN_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/plans",
        reduce: function (employee) {
          return employee.id;
        },
        getOptionLabel: function (employee) {
          return employee.year;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    year: {
      component: "FormInput",
      key: "year",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    status: {
      component: "FormSelect",
      key: "status",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "قيد التخطيط",
            value: "planning",
          },
          {
            text: "بانتظار رد الوزارة",
            value: "awaiting",
          },
          {
            text: "مقبولة",
            value: "accepted",
          },
          {
            text: "مرفوضة",
            value: "rejected",
          },
          {
            text: "فعالة",
            value: "active",
          },
          {
            text: "مؤرشفة",
            value: "archived",
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.ANNUAL_BUDGET_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/annual-budgets",
        reduce: function (budget) {
          return budget.id;
        },
        getOptionLabel: function (budget) {
          return budget.year;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    year: {
      component: "FormInput",
      key: "year",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    final_budget: {
      component: "FormCurrency",
      key: "final_budget",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    next_year_budget: {
      component: "FormCurrency",
      key: "next_year_budget",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.ASSIST_OBJECT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/assist-objects",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.title;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    title: {
      component: "FormInput",
      key: "title",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description: {
      component: "FormInput",
      key: "description",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    count: {
      component: "FormInput",
      key: "description",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    demanded: {
      component: "FormSelect",
      key: "demanded",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "استفد",
            value: true,
          },
          {
            text: "امنح",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.ASSIST_CATEGORY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/assist-categories",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.BOARD_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/board-types",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.DIRECTOR_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/directors",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    dob: {
      component: "FormMultiDatepicker",
      key: "dob",
      attrs: {
        id: uuidGenerate(),
      },
    },
    phone_number: {
      component: "FormInput",
      key: "phone_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.DIRECTOR_BOARD_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/director-boards",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.board_year;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    board_year: {
      component: "FormInput",
      key: "board_year",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    board_end_year: {
      component: "FormMultiDatepicker",
      key: "board_end_year",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.DIRECTOR_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/director-types",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.DIVISION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/divisions",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.ESTABLISHMENT_ACCOUNT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/establishment-accounts",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.username;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    first_name: {
      component: "FormInput",
      key: "first_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    last_name: {
      component: "FormInput",
      key: "last_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    father_name: {
      component: "FormInput",
      key: "father_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    username: {
      component: "FormInput",
      key: "username",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    phone_number: {
      component: "FormInput",
      key: "phone_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    id_number: {
      component: "FormInput",
      key: "id_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    email: {
      component: "FormInput",
      key: "email",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_active: {
      component: "FormSelect",
      key: "is_active",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    validated: {
      component: "FormSelect",
      key: "validated",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.ESTABLISHMENT_MEMBER_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/establishment-members",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.full_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    full_name: {
      component: "FormInput",
      key: "full_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    id_number: {
      component: "FormInput",
      key: "id_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    phone_number: {
      component: "FormInput",
      key: "phone_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    qualifications: {
      component: "FormInput",
      key: "qualifications",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    jobs: {
      component: "FormInput",
      key: "jobs",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_active: {
      component: "FormSelect",
      key: "is_active",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    validated: {
      component: "FormSelect",
      key: "validated",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.ESTABLISHMENT_NGO_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/establishment-ngos",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.ngo_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    ngo_name: {
      component: "FormInput",
      key: "ngo_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    fst_alt_ngo_name: {
      component: "FormInput",
      key: "fst_alt_ngo_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    sec_alt_ngo_name: {
      component: "FormInput",
      key: "sec_alt_ngo_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    accepted_ngo_name: {
      component: "FormInput",
      key: "accepted_ngo_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    real_estate_number: {
      component: "FormInput",
      key: "real_estate_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    objectives: {
      component: "FormInput",
      key: "objectives",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    headquarters_address: {
      component: "FormInput",
      key: "headquarters_address",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    status: {
      component: "FormSelect",
      key: "status",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "في مرحلة تدقيق المعلومات",
            value: "info_evaluating",
          },
          {
            text: "تم تدقيق المعلومات",
            value: "info_evaluated",
          },
          {
            text: "في مرحلة تدقيق الملفات",
            value: "docs_evaluating",
          },
          {
            text: "تم تدقيق الملفات",
            value: "docs_evaluated",
          },
          {
            text: "مكتملة",
            value: "done",
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    occupation_legal_form: {
      component: "FormSelect",
      key: "occupation_legal_form",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "إيجار",
            value: "lease",
          },
          {
            text: "حق انتفاع",
            value: "usufruct",
          },
          {
            text: "عارية",
            value: "loan",
          },
          {
            text: "administrative_allocation",
            value: "administrative_allocation",
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    legal_form_type: {
      component: "FormSelect",
      key: "status",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "جمعية",
            value: "association",
          },
          {
            text: "مؤسسة",
            value: "institution",
          },
          {
            text: "اتحاد",
            value: "alliance",
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    is_active: {
      component: "FormSelect",
      key: "is_active",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    validated: {
      component: "FormSelect",
      key: "validated",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.FAQ_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/faqs",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.answer_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    question_ar: {
      component: "FormInput",
      key: "question_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    answer_ar: {
      component: "FormInput",
      key: "answer_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    question_en: {
      component: "FormInput",
      key: "question_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    answer_en: {
      component: "FormInput",
      key: "answer_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.FAQ_CATEGORY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/faq-categories",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    type: {
      component: "FormInput",
      key: "type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.GENERAL_AUTHORITY_MEMBER_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/general-authority-members",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.full_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    full_name: {
      component: "FormInput",
      key: "full_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    id_number: {
      component: "FormInput",
      key: "id_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    phone_number: {
      component: "FormInput",
      key: "phone_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    gender: {
      component: "FormSelect",
      key: "gender",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "ذكر",
            value: true,
          },
          {
            text: "أنثى",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    dob: {
      component: "FormMultiDatepicker",
      key: "dob",
      attrs: {
        id: uuidGenerate(),
      },
    },
    affiliation_date: {
      component: "FormMultiDatepicker",
      key: "affiliation_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.INCENTIVE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/incentives",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    type: {
      component: "FormInput",
      key: "type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    decision_no: {
      component: "FormInput",
      key: "decision_no",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    decision_date: {
      component: "FormMultiDatepicker",
      key: "decision_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    read_at: {
      component: "FormMultiDatepicker",
      key: "read_at",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.INCENTIVE_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/incentive-types",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.JOB_TITLE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/job-titles",
        reduce: function (job) {
          return job.id;
        },
        getOptionLabel: function (job) {
          return job.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.MEETING_MINUTE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/meeting-minutes",
        reduce: function (job) {
          return job.id;
        },
        getOptionLabel: function (job) {
          return job.title;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    title: {
      component: "FormInput",
      key: "title",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    attendance_names: {
      component: "FormInput",
      key: "attendance_names",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    note: {
      component: "FormInput",
      key: "note",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    meeting_date: {
      component: "FormMultiDatepicker",
      key: "meeting_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    seen_at: {
      component: "FormMultiDatepicker",
      key: "seen_at",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.MEETING_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/meeting-types",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name_ar;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name_ar: {
      component: "FormInput",
      key: "name_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    name_en: {
      component: "FormInput",
      key: "name_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.MINISTRY_PERMISSION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ministry-permissions",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    type: {
      component: "FormInput",
      key: "type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.MINISTRY_ROLE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ministry-roles",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    selected: {
      component: "FormSelect",
      key: "selected",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.MINISTRY_USER_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ministry-users",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.full_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    full_name: {
      component: "FormInput",
      key: "full_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    username: {
      component: "FormInput",
      key: "username",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    mobile: {
      component: "FormInput",
      key: "mobile",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    phone: {
      component: "FormInput",
      key: "phone",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    email: {
      component: "FormInput",
      key: "email",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_blocked: {
      component: "FormSelect",
      key: "is_blocked",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    is_locked: {
      component: "FormSelect",
      key: "is_locked",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    ministry_user_type: {
      component: "FormSelect",
      key: "ministry_user_type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "موظف مركزي",
            value: true,
          },
          {
            text: "موظف فرعي",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.NGO_PERMISSION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ngo-permissions",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.NGO_ROLE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/ngo-roles",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    slug: {
      component: "FormInput",
      key: "slug",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    selected: {
      component: "FormSelect",
      key: "selected",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.ORGANIZATIONAL_INFORMATION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/organizational-information",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.board_election_date;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    board_members_count: {
      component: "FormInput",
      key: "board_members_count",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    board_election_date: {
      component: "FormMultiDatepicker",
      key: "board_election_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
    term_of_office: {
      component: "FormInput",
      key: "term_of_office",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    public_authority_total_count: {
      component: "FormInput",
      key: "public_authority_total_count",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    authorised_to_vote_count: {
      component: "FormInput",
      key: "authorised_to_vote_count",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    public_authority_last_meeting: {
      component: "FormMultiDatepicker",
      key: "public_authority_last_meeting",
      attrs: {
        id: uuidGenerate(),
      },
    },
    members_type: {
      component: "FormSelect",
      key: "members_type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "مجلس إدارة",
            value: true,
          },
          {
            text: "مجلس أمناء",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  Inputs.PAYMENT_METHOD_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/payment-methods",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.phone_number;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    phone_number: {
      component: "FormInput",
      key: "phone_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    username: {
      component: "FormInput",
      key: "username",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    active: {
      component: "FormSelect",
      key: "active",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    terminal_id: {
      component: "FormInput",
      key: "terminal_id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.PAYMENT_METHOD_TYPE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/payment-method-types",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.PROJECT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/projects",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    cooperation_relation: {
      component: "FormInput",
      key: "cooperation_relation",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    ben_number: {
      component: "FormInput",
      key: "ben_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    working_employees_number: {
      component: "FormInput",
      key: "working_employees_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    working_volunteers_number: {
      component: "FormInput",
      key: "working_volunteers_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_employees_number: {
      component: "FormInput",
      key: "total_employees_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_volunteers_number: {
      component: "FormInput",
      key: "total_volunteers_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    perma_vacancies_number: {
      component: "FormInput",
      key: "perma_vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    tempo_vacancies_number: {
      component: "FormInput",
      key: "tempo_vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_vacancies_number: {
      component: "FormInput",
      key: "total_vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    expected_budget: {
      component: "FormCurrency",
      key: "expected_budget",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    register_date: {
      component: "FormMultiDatepicker",
      key: "register_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.PROJECT_ACTIVITY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/project-activities",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    code: {
      component: "FormInput",
      key: "code",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    cooperation_relation: {
      component: "FormInput",
      key: "cooperation_relation",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    ben_number: {
      component: "FormInput",
      key: "ben_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    working_employees_number: {
      component: "FormInput",
      key: "working_employees_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    working_volunteers_number: {
      component: "FormInput",
      key: "working_volunteers_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_employees_number: {
      component: "FormInput",
      key: "total_employees_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_volunteers_number: {
      component: "FormInput",
      key: "total_volunteers_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    perma_vacancies_number: {
      component: "FormInput",
      key: "perma_vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    tempo_vacancies_number: {
      component: "FormInput",
      key: "tempo_vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_vacancies_number: {
      component: "FormInput",
      key: "total_vacancies_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    expected_budget: {
      component: "FormCurrency",
      key: "expected_budget",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    register_date: {
      component: "FormMultiDatepicker",
      key: "register_date",
      attrs: {
        id: uuidGenerate(),
      },
    },
  };
  Inputs.PROJECT_DIVISION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/project-divisions",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.expected_budget;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    expected_budget: {
      component: "FormCurrency",
      key: "expected_budget",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    ben_number: {
      component: "FormInput",
      key: "ben_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    ben_women_percentage: {
      component: "FormInput",
      key: "ben_women_percentage",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    ben_disabled_percentage: {
      component: "FormInput",
      key: "ben_disabled_percentage",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.PROJECT_FINANCIAL_INFORMATION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/project-financial-information",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.bank_name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    bank_name: {
      component: "FormInput",
      key: "bank_name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    bank_governorate: {
      component: "FormInput",
      key: "bank_governorate",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    bank_address: {
      component: "FormInput",
      key: "bank_address",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    expected_budget_usd: {
      component: "FormCurrency",
      key: "expected_budget_usd",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    expected_budget_sp: {
      component: "FormCurrency",
      key: "expected_budget_sp",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    total_budget: {
      component: "FormCurrency",
      key: "total_budget",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    administrative_expenses_percentage: {
      component: "FormInput",
      key: "administrative_expenses_percentage",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    un_agent_contribution_value: {
      component: "FormCurrency",
      key: "un_agent_contribution_value",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    local_ngo_contribution_value: {
      component: "FormCurrency",
      key: "local_ngo_contribution_value",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.PROJECT_GOVERNORATE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/project-governorates",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.expected_budget;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    expected_budget: {
      component: "FormCurrency",
      key: "expected_budget_usd",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    ben_number: {
      component: "FormInput",
      key: "ben_number",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.PROJECT_OBJECTIVE_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/project-objectives",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.REQUEST_HISTORY_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/request-histories",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.action_type;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    action_type: {
      component: "FormInput",
      key: "action_type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.UN_AGENT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/un-agents",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.WEIGHT_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/weights",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    token: {
      component: "FormInput",
      key: "token",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    link: {
      component: "FormInput",
      key: "link",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    mark: {
      component: "FormInput",
      key: "mark",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    completion_value: {
      component: "FormInput",
      key: "completion_value",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.DONOR_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/donors",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.name;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    name: {
      component: "FormInput",
      key: "name",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_famous: {
      component: "FormSelect",
      key: "is_famous",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (aObject) {
          return aObject.value;
        },
        getOptionLabel: function (aObject) {
          return aObject.text;
        },
      },
    },
    donated_amount: {
      component: "FormCurrency",
      key: "donated_amount",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    donated_type: {
      component: "FormSelect",
      key: "donated_type",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        options: [
          {
            text: "عيني",
            value: true,
          },
          {
            text: "مادي",
            value: false,
          },
        ],
        reduce: function (aObject) {
          return aObject.value;
        },
        getOptionLabel: function (aObject) {
          return aObject.text;
        },
      },
    },
  };
  Inputs.ASSIST_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/assists",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.id;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
  };
  Inputs.QUALIFICATION_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/qualifications",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.title;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    title: {
      component: "FormInput",
      key: "title",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
  };
  Inputs.EVENTS_SCHEMA = {
    id: {
      component: "FormSelect",
      key: "id",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
        ep: "v2/ministry/selects/graphql/qualifications",
        reduce: function (aObject) {
          return aObject.id;
        },
        getOptionLabel: function (aObject) {
          return aObject.title;
        },
        multiple: true,
        closeOnSelect: false,
      },
    },
    title_ar: {
      component: "FormInput",
      key: "title_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    title_en: {
      component: "FormInput",
      key: "title_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    from_event_date: {
      component: "FormInput",
      key: "from_event_date",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    to_event_date: {
      component: "FormInput",
      key: "to_event_date",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    from_event_duration: {
      component: "FormInput",
      key: "from_event_duration",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    to_event_duration: {
      component: "FormInput",
      key: "to_event_duration",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    from_time: {
      component: "FormInput",
      key: "from_time",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    to_time: {
      component: "FormInput",
      key: "to_time",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description_ar: {
      component: "FormInput",
      key: "description_ar",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    description_en: {
      component: "FormInput",
      key: "description_en",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    image_event: {
      component: "FormInput",
      key: "image_event",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    location: {
      component: "FormInput",
      key: "location",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    link: {
      component: "FormInput",
      key: "link",
      attrs: {
        id: uuidGenerate(),
        rules: "required",
      },
    },
    is_full_day: {
      component: "FormSelect",
      key: "is_full_day",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "نعم",
            value: true,
          },
          {
            text: "لا",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
    invitation_type: {
      component: "FormSelect",
      key: "invitation_type",
      attrs: {
        id: uuidGenerate(),
        options: [
          {
            text: "عامة",
            value: true,
          },
          {
            text: "خاصة",
            value: false,
          },
        ],
        reduce: function (option) {
          return option.value;
        },
        getOptionLabel: function (option) {
          return option.text;
        },
      },
    },
  };
  return Inputs;
})();
